import { MenuItem, PageHeader, PageHeaderProps, styled } from '@fme-nova/components'
import type { ComponentPropsWithoutRef } from 'react'

import { createComponentWrapperWithRef, uiTokens } from '../../theme'

const StyledNovaPageHeader = styled(PageHeader)`
  border-bottom: none;
  padding: 20px 24px 8px;
  > div > div {
    height: 60px;
  }
`

const StyledMuiPageHeader = styled(PageHeader)`
  border-bottom: none;
  padding: 20px 24px 8px;
  h1 {
    margin: 0;
    font-size: 1.75rem;
    font-style: normal;
    font-weight: 700;
    line-height: 114.2%;
  }
  div:nth-of-type(2) > :nth-child(2) > button > svg {
    color: var(--msdk-colors-primary-main);
  }
`

const StyledNovaMenuItem = styled(MenuItem)`
  gap: ${uiTokens.spacing.gap.small}px;
`

const StyledMuiMenuItem = styled(MenuItem)`
  gap: ${uiTokens.spacing.gap.small}px;
`

export const StyledMenuItem = createComponentWrapperWithRef<ComponentPropsWithoutRef<typeof MenuItem>>(
  {
    mui: StyledMuiMenuItem,
    nova: StyledNovaMenuItem,
  },
  'StyledMenuItem',
)

export const ViewHeader = createComponentWrapperWithRef<PageHeaderProps>(
  {
    mui: StyledMuiPageHeader,
    nova: StyledNovaPageHeader,
  },
  'ViewHeader',
)
